// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayorSharedContactUpsearchModel {
    static getAttributeTypeMap() {
        return PayorSharedContactUpsearchModel.attributeTypeMap;
    }
}
PayorSharedContactUpsearchModel.discriminator = undefined;
PayorSharedContactUpsearchModel.additionalProperties = false;
PayorSharedContactUpsearchModel.attributeTypeMap = [
    {
        "name": "addresses",
        "baseName": "addresses",
        "type": ""
    },
    {
        "name": "emailAddresses",
        "baseName": "emailAddresses",
        "type": ""
    },
    {
        "name": "phoneNumbers",
        "baseName": "phoneNumbers",
        "type": ""
    },
    {
        "name": "webAddresses",
        "baseName": "webAddresses",
        "type": ""
    },
    {
        "name": "contactId",
        "baseName": "contactId",
        "type": "number"
    },
    {
        "name": "contactType",
        "baseName": "contactType",
        "type": "RoleType"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "occupationDescription",
        "baseName": "occupationDescription",
        "type": "string"
    },
    {
        "name": "isMainContact",
        "baseName": "isMainContact",
        "type": "boolean"
    },
];
//# sourceMappingURL=payorSharedContactUpsearchModel.js.map